import type { Theme } from '.';

const rootStyles = (theme: Theme) => {
  return {
    body: {
      margin: 0,
      fontFamily: theme.fonts.root,
      fontWeight: theme.fontWeights.body,
      lineHeight: theme.lineHeights.scale[3],
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    // not sure how to do this otherwise
    'input[type=checkbox]:disabled ~ svg': {
      opacity: 0.5,
      color: 'gray',
      cursor: 'not-allowed',
    },
  };
};

export default rootStyles;
